import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';

const StepDot = ({ active }: { active: boolean }) => {
  return (
    <div
      data-testid="wid-invitee-step-dot"
      className={twMerge(
        'w-7 h-7 flex items-center justify-center rounded-full box-border',
        !active && 'border-2 border-solid border-surface-100-hairline bg-surface-100-bg',
        active && 'bg-btn-primary-bg/20'
      )}>
      <div
        data-testid="wid-invitee-step-dot-inner"
        data-selected={active}
        className={twMerge('w-5 h-5 rounded-full bg-surface-100-bg', active && 'bg-btn-primary-bg')}></div>
    </div>
  );
};

const InviteeStep = ({ currentStep = 0 }: { currentStep: number }) => {
  const { t } = useTranslation('common');

  const steps = [
    {
      content: t('referral_status_fillin'),
      index: 0
    },
    {
      content: t('referral_status_register'),
      index: 1
    },
    {
      content: t('referral_status_begin'),
      index: 2
    }
  ];

  return (
    <div data-testid="wid-invitee-step" className="px-5 pt-3 pb-4 flex items-center">
      <div className="w-full relative">
        <div className="absolute top-[14px] left-1 w-[calc(100%-8px)] h-0.5 bg-surface-100-hairline rounded-full"></div>
        <div data-testid="wid-invitee-step-content" className="w-full flex items-center justify-between relative z-1">
          {steps.map((step, index) => {
            return (
              <div
                data-testid={`wid-invitee-step-${index}`}
                key={index}
                className={twMerge(
                  'flex flex-col items-center',
                  index === 0 && 'items-start',
                  index === steps.length - 1 && 'items-end'
                )}>
                <StepDot active={currentStep === index} />
                <span
                  data-testid={`wid-invitee-step-${index}-text`}
                  data-selected={currentStep === index}
                  className={twMerge(
                    'text-surface-100-fg-minor enki-body-2xs-medium mt-1',
                    currentStep === index && 'text-root-flow-teal-dark-3'
                  )}>
                  {step.content}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InviteeStep;
